package tables.organization

import emotion.react.css
import kotlinx.browser.window
import models.OrganizationModel
import org.w3c.fetch.RequestInit
import react.FC
import react.Props
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.table
import react.dom.html.ReactHTML.tbody
import react.dom.html.ReactHTML.td
import react.dom.html.ReactHTML.th
import react.dom.html.ReactHTML.thead
import react.dom.html.ReactHTML.tr
import react.useEffect
import react.useState
import token
import urlAddress
import web.cssom.*
import web.html.InputType

external interface OrganisationProps : Props

val OrganisationTable = FC<OrganisationProps> {

    val (organisations, setOrganisations) = useState(emptyList<OrganizationModel>())
    var organisationName by useState("")
    var isModalOpenUpdate: OrganizationModel? by useState(null)
    var isModalOpenCreate by useState(false)
    var isModalOpenView by useState(0)

    fun loadOrganisations() {
        window.fetch(urlAddress + "api/organization", RequestInit(
            method = "GET",
            headers = web.http.Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response -> response.json() }
            .then { data ->
                val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                    OrganizationModel(
                        it.id as? Int ?: 0,
                        it.name as? String ?: "",
                        it.sait as? String ?: "",
                        it.note as? String ?: "",
                        it.userName as? String ?: "",
                        it.isactive as? Boolean ?: true,
                    )
                }
                setOrganisations(newResultList)
            }
    }



    useEffect(organisations.isEmpty()) {
        loadOrganisations()
    }

    UpdateOrgModal {
        organizationModel = isModalOpenUpdate
        onClose = {
            isModalOpenUpdate = null
        }
        onUpdate = {
            loadOrganisations()
        }
    }
    CreateOrgModal {
        isOpen = isModalOpenCreate
        onClose = {
            isModalOpenCreate = false
        }
        onUpdate = {
            loadOrganisations()
        }
    }

    ViewOrgModal {
        idOrg = isModalOpenView
        onClose = {
            isModalOpenView = 0
        }
    }

    div {
        div {
            +"Введите наименование Организации:"
            input {
                css {
                    fontSize = 14.px
                }
                value = organisationName
                type = InputType.text
                onChange = { event ->
                    organisationName = event.target.value
                }
            }
            button {
                +"Добавить"
                onClick = {
                    isModalOpenCreate = true
                }
            }
        }

        table {
            border = 1
            css {
                borderColor = Color("#000")
                borderCollapse = BorderCollapse.collapse
                textAlign = TextAlign.center
            }
            thead {
                tr {
                    th { +"Наименование" }
                    th { +"Сайт" }
                    th { +"Описание" }
                    th { +"Пользователь" }
                    th { +"Активная" }
                    th { +"Действие" }
                }
            }
            tbody {
                organisations.filter { it.name.lowercase().contains(organisationName.lowercase()) }.forEach { item ->
                    tr {
                        td { +item.name }
                        td {
                            a {
                                href = item.sait
                                +item.sait
                            }
                        }
                        td { +item.note }
                        td { +item.userName }
                        td { +"${item.isactive}" }
                        td {
                            div {
                                css {
                                    display = Display.flex
                                    flexDirection = FlexDirection.row
                                    alignItems = AlignItems.center
                                    justifyContent = JustifyContent.center
                                }
                                button {
                                    css {
                                        margin = 5.px
                                        marginBottom = 5.px
                                        fontSize = 14.px
                                    }
                                    +"✏️"
                                    onClick = {
                                        isModalOpenUpdate = item
                                    }
                                }
                                button {
                                    css {
                                        margin = 5.px
                                        marginBottom = 5.px
                                        fontSize = 14.px
                                    }
                                    +"👁️"
                                    onClick = {
                                        isModalOpenView = item.id
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

}

